import { render, staticRenderFns } from "./Clip.vue?vue&type=template&id=19eefbbc&scoped=true&"
import script from "./Clip.vue?vue&type=script&lang=js&"
export * from "./Clip.vue?vue&type=script&lang=js&"
import style0 from "./Clip.vue?vue&type=style&index=0&id=19eefbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eefbbc",
  null
  
)

export default component.exports